export default class LearningReviewGroup {
  isAllGroup: boolean;
  isUnspecifiedGroup: boolean;
  groupName: string;
  totalTermsCount: number;
  correctTermsCount: number;
  incorrectTermsCount: number;
  isSelected: boolean;

  constructor(
    isAllGroup: boolean,
    isUnspecifiedGroup: boolean,
    groupName: string,
    totalTermsCount: number,
    correctTermsCount: number,
    incorrectTermsCount: number,
    isSelected: boolean
  ) {
    this.isAllGroup = isAllGroup;
    this.isUnspecifiedGroup = isUnspecifiedGroup;
    this.groupName = groupName;
    this.totalTermsCount = totalTermsCount;
    this.correctTermsCount = correctTermsCount;
    this.incorrectTermsCount = incorrectTermsCount;
    this.isSelected = isSelected;
  }
}

function compareGroupPriority(
  a: LearningReviewGroup,
  b: LearningReviewGroup
): number {
  if (a.isAllGroup !== b.isAllGroup) {
    return a.isAllGroup ? -1 : 1;
  }
  if (a.isUnspecifiedGroup !== b.isUnspecifiedGroup) {
    return a.isUnspecifiedGroup ? -1 : 1;
  }
  return 0;
}

export function sortByNameLearningReviewGroup(
  items: LearningReviewGroup[]
): LearningReviewGroup[] {
  return [...items].sort((a, b) => {
    const priority = compareGroupPriority(a, b);
    if (priority !== 0) return priority;
    return a.groupName.localeCompare(b.groupName);
  });
}

export function sortByTotalTermsCountLearningReviewGroup(
  items: LearningReviewGroup[]
): LearningReviewGroup[] {
  return [...items].sort((a, b) => {
    const priority = compareGroupPriority(a, b);
    if (priority !== 0) return priority;
    return b.totalTermsCount - a.totalTermsCount;
  });
}

export function sortByTotalTermsCountReverseLearningReviewGroup(
  items: LearningReviewGroup[]
): LearningReviewGroup[] {
  return [...items].sort((a, b) => {
    const priority = compareGroupPriority(a, b);
    if (priority !== 0) return priority;
    return a.totalTermsCount - b.totalTermsCount;
  });
}

export function sortByIncorrectTermsCountLearningReviewGroup(
  items: LearningReviewGroup[]
): LearningReviewGroup[] {
  return [...items].sort((a, b) => {
    const priority = compareGroupPriority(a, b);
    if (priority !== 0) return priority;
    return b.incorrectTermsCount - a.incorrectTermsCount;
  });
}
